import { FC } from "react";

import { NotificationPriorityEnum } from "@ryde/shared";

import {
  StatusIndicatorNotificationMap,
  StatusIndicatorStyled,
} from "../../common";
import { IRenderColumnTemplate } from "./_core";

export const NotificationPriorityCellTemplate: FC<IRenderColumnTemplate> = ({
  value,
  valueTranslated,
}) => {
  const statusStyles =
    StatusIndicatorNotificationMap[value as NotificationPriorityEnum];
  return (
    <StatusIndicatorStyled
      $bgColor={statusStyles.$bgColor}
      $borderColor={statusStyles.$borderColor}
      $color={statusStyles.$color}
    >
      {valueTranslated}
    </StatusIndicatorStyled>
  );
};
